// extracted by mini-css-extract-plugin
module.exports = {"practiceReports":"PracticeReports_practiceReports__1Bu1U"};